
import { Options, Vue } from 'vue-class-component';
import {
  Listbox, ListboxButton, ListboxLabel, ListboxOption, ListboxOptions,
} from '@headlessui/vue';
import { CheckIcon, SelectorIcon } from '@heroicons/vue/solid';

@Options({
  props: {
    modelValue: { id: Number, name: String },
    items: Array,
  },
  components: {
    Listbox,
    ListboxButton,
    ListboxLabel,
    ListboxOption,
    ListboxOptions,
    CheckIcon,
    SelectorIcon,
  },
})
export default class SelectMenu extends Vue {
  modelValue: { id: number, name: string } | null | undefined = null;

  items!: { id: number, name: string }[];

  get selectedName(): string {
    return this.modelValue?.name ?? '';
  }

  get selectedValue(): { id: number, name: string} | null | undefined {
    return this.modelValue;
  }

  set selectedValue(val: { id: number, name: string} | null | undefined) {
    this.$emit('update:modelValue', val);
  }
}
